import React from "react";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
// material-ui icons
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ModalPregunta from "components/Generales/ModalPregunta";
import ModalAgregarUnidadMedida from "views/Modulos/Administracion/UnidadMedida/ModalAgregarUnidadMedida.jsx";
import Globales from "utils/Globales";
import { Edit, Close, AddCircle, Search, Clear, Filter9Plus } from "@material-ui/icons";
import ReactLoading from "react-loading";

class UnidadMedida extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: '',
      NombreUnidad: '',
      Abreviacion: '',
      Titulo: '',
      unidadesMedidas: [],
      mensaje: '',
      br: false,
      colorNotificacion: 'success',
      errorNombre: false,
      errorAbreviacion: false,
      unidadMedidaMostrar: [],
      entroFiltrar: false,
      notificacion: false
    };
    //Variable global para indicar el total de registros que se obtendra de la base de datos
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.eventoModalEliminar = this.eventoModalEliminar.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.eliminarUnidadMedida = this.eliminarUnidadMedida.bind(this);
    this.filtrarUnidadMedida = this.filtrarUnidadMedida.bind(this);
    this.seleccionado = {};
  }

  componentDidMount() {
    this.obtenerUnidadMedidaFin();
    this.obtenerAllUnidadesMedidas();
  }

  //Obtener todos los registros guardados
  obtenerAllUnidadesMedidas() {
    fetch(Globales.Url + 'UnidadMedida/UnidadMedida/', {
      method: 'GET',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) { //Error al obtener los registros
          this.setState({ unidadesMedidas: [] });
        } else { //Obtuvo los registros correctamente
          this.setState({ unidadesMedidas: data.data });
        }
      });
  }

  //Obtener el total de registros que se indican
  obtenerUnidadMedidaFin() {
    fetch(Globales.Url + 'UnidadMedida/UnidadMedida/ListaUnidadMedida', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ Fin: global.Fin })
    }
    ).then(res => {
      global.response = res.status;
      res.json()
        .then(data => {
          if (data.error) { //Error al obtener los registros
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else { //Obtuvo los registros correctamente
            this.setState({ unidadMedidaMostrar: data.mensaje });
          }
        })
        .catch(err => console.error(err));
    });
  }

  //Función de editar registro
  editarUnidadMedida(id, Nombre, Abreviacion) {
    this.setState({ _id: id, NombreUnidad: Nombre, Abreviacion: Abreviacion, op: 1, showAgregar: true, Titulo: "Editar Unidad de Medida" });
  }

  //Función de eliminar registro
  eliminarUnidadMedida(id) {
    fetch(Globales.Url + 'UnidadMedida/UnidadMedida/BajaUnidadMedida', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ _id: id })
    }
    ).then(res => res.json())
      .then(data => {
        if (data.error) {//Error al obtener los registros
          this.setState({ colorNotificacion: 'danger' });
        } else {//Obtuvo los registros correctamente
          this.setState({ colorNotificacion: 'success' });
        }
        this.setState({ mensaje: data.mensaje, show: false });
        this.showNotification("tr");
        this.obtenerUnidadMedidaFin();
        this.limpiar();
      });
  }

  //Función para el evento de eliminar
  deleteEvent = (values) => {
    this.seleccionado = values;
    this.setState({ show: true });
  }

  //Función para habilitar el modal de eliminar
  eventoModalEliminar(e) {
    if (!e) {
      this.setState({ show: false });
      return;
    }
    //Eliminar el elemento
    this.eliminarUnidadMedida(this.seleccionado);
  }

  //Función para abrir el modal de agregar registro
  openModalAgregarUnidadMedida = () => {
    this.setState({ showAgregar: true, Titulo: "Nueva Unidad de Medida", op: 0 });
  }

  //Función que recupera valores para el modal de agregar
  eventoModalEstatusPedido = (mensaje, colorNotificacion) => {
    //Cambiar valores por default
    this.setState({ showAgregar: false, Titulo: "Nueva Unidad de Medida", NombreUnidad: "", Abreviacion: "", op: 0 })
    this.obtenerUnidadMedidaFin();
    this.obtenerAllUnidadesMedidas();
    this.limpiar();
    //Validar que el mensaje venga diferente de vacio
    if (mensaje !== 'esc') {
      this.setState({ mensaje: mensaje, colorNotificacion: colorNotificacion })
      this.showNotification();
    }
  }

  //Función que habilita la notificación
  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false, notificacion: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  //Función para obtener el texto de los inputs
  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  //Función para realizar el filtrado de búsqueda
  filtrarUnidadMedida() {
    var valor1 = 0;
    //Validar que el input no este vacio
    if (this.state.NombreUnidad.trim() == '') {
      this.setState({ errorNombre: true, colorNotificacion: 'danger', mensaje: "Complete el campo de búsqueda", NombreUnidad: '' });
      valor1 = 1;
    } else {
      this.setState({ errorNombre: false });
      valor1 = 0;
    }
    //Validar si hay campos requeridos
    if (valor1 > 0) { //Hay campos requeridos
      this.showNotification();
    } else { //No hay campos requeridos
      fetch(Globales.Url + 'UnidadMedida/UnidadMedida/FiltrarUnidadMedida', {
        method: 'POST',
        headers: {
          Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
        }
        , body: JSON.stringify(this.state)
      }
      ).then(res => res.json())
        .then(data => {

          if (data.error) { //Error en la respuesta
            this.setState({ colorNotificacion: 'danger', mensaje: data.mensaje });
            this.showNotification();
          } else if (data.mensaje.length == 0) { //Ninguna coincidencia
            this.setState({ colorNotificacion: "warning",  unidadMedidaMostrar:[],mensaje: "No hay ninguna coincidencia", entroFiltrar: true })
            this.showNotification();
          } else { //Filtrado exitoso
            this.setState({ colorNotificacion: 'success', unidadMedidaMostrar: data.mensaje, entroFiltrar: true })
          }
        })
        .catch(err => console.error(err));
    }
  }

  //Función para volver los valores por default
  limpiar() {
    this.setState({ NombreUnidad: '', entroFiltrar: false });
    global.Fin = 5;
    global.entrar = true;
    global.response = null;
    this.obtenerUnidadMedidaFin();
    this.obtenerAllUnidadesMedidas();
  }

  //Función para mostrar mas registros en la tabla
  verMas() {
    //Validar si entro a filtrar
    if (this.state.entroFiltrar) {
      this.limpiar();
    } else {
      //Creando variable con mas valor que la variable global
      var num = global.Fin + 5;
      var mostrarMensaje = false;
      if(this.state.unidadesMedidas.length <= global.Fin){
        mostrarMensaje = true;
      }
      //Validación de el valor de la variable global sea menor o igual que el total de registros obtenidos
      if (num <= this.state.unidadesMedidas.length && global.entrar) {
        //Cambiando el valor de la variable global
        global.Fin = num;
        //Obteniendo el número de registros requeridos
        this.obtenerUnidadMedidaFin();
      };
      //Validación de que el número total de registros requiridos sea mayor al total de registros y cambio de valor de variables
      if (num > this.state.unidadesMedidas.length && global.entrar) {
        //Cambiando el valor de la variable para que no vuelva a traer mas registros
        global.entrar = false;
        //Cambiando el valor de la variable global
        global.Fin = this.state.unidadesMedidas.length;
        //Obteniendo el total de los registros requeridos
        this.obtenerUnidadMedidaFin();
      };
      //Validación de que ya no hay mas registros que mostrar
      if (mostrarMensaje) {
        this.setState({ mensaje: 'No hay más unidades de medida para mostrar', colorNotificacion: 'warning' });
        this.showNotification();
      };
    }
  }

  render() {
    let agregar;
    if (this.state.showAgregar == true) {
      agregar =
        <ModalAgregarUnidadMedida
          Titulo={this.state.Titulo}
          NombreUnidad={this.state.NombreUnidad}
          Abreviacion={this.state.Abreviacion}
          _id={this.state._id}
          showAgregar={this.state.showAgregar}
          eventClick={this.eventoModalEstatusPedido}
          op={this.state.op}
        />
    }
    const { classes } = this.props;
    return (
      <div>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info" text>
                <h4 className={classes.cardTitle}>Unidad de Medida</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Buscar unidad de medida"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        required: true,
                        onChange: this.handleChange,
                        value: this.state.NombreUnidad,
                        name: "NombreUnidad",
                        id: "NombreUnidad",
                        type: "text",
                        error: this.state.errorNombre
                      }}
                      className="mt-5"
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="info" round onClick={() => this.filtrarUnidadMedida()}><Search />Buscar</Button>
                    <Button size="sm" type="submit" className="pull-left mt-5" color="danger" round onClick={() => this.limpiar()}><Clear />Limpiar</Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="info" round onClick={() => this.verMas()}><Filter9Plus />Ver Más</Button>
                    <Button size="sm" type="submit" className="pull-right mt-5" color="success" round onClick={() => this.openModalAgregarUnidadMedida()}><AddCircle />Agregar</Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          {/* Tabla de unidadesMedidas */}
          <GridItem xs={12} sm={12} md={10}>
            <Card>
              <CardHeader color="info">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={7}>
                    <h4 className="pull-left">Lista de Unidades de Medida</h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                {global.response === 200 ?
                  <div className="table-wrapper-scroll-y">
                    <table className="col-xs-12 col-sm-12 col-md-12">
                      <thead>
                        <th className="center">Nombre</th>
                        <th className="center">Abreviación</th>
                        <th className="pull-right">Acciones</th>
                      </thead>
                      <tbody>
                        {this.state.unidadMedidaMostrar.map(UnidadMedida => {
                          return (
                            <tr key={UnidadMedida._id}>
                              <td>{UnidadMedida.NombreUnidad}</td>
                              <td>{UnidadMedida.Abreviacion}</td>
                              <td className="pull-right">
                                <Button color="warning" round justIcon size="sm" onClick={() => this.editarUnidadMedida(UnidadMedida._id, UnidadMedida.NombreUnidad, UnidadMedida.Abreviacion)}><Edit /></Button>
                                <Button color="danger" round justIcon size="sm" onClick={() => this.deleteEvent(UnidadMedida._id)}><Close /></Button>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div> :
                  <GridContainer justify='center'>
                    <ReactLoading type={'bubbles'} color={'#CFCFCF'} height={'10%'} width={'10%'} />
                  </GridContainer>
                }

              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <div id="">
          <ModalPregunta
            Titulo={"Eliminar Unidad de Medida"}
            Cuerpo={"¿Está seguro que desea eliminar la unidad de medida?"}
            show={this.state.show}
            eventClick={this.eventoModalEliminar}
          />
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    )
  }
}

export default withStyles(headerLinksStyle)(UnidadMedida);